/**
 * 诊断结论知识库
 * 诊断模型管理
 * 模型自诊断记录
 */
import _ from 'lodash'
import axios from "../axios"
import {
    IDiagnosisConclusionRepositorAddParams,
    IDiagnosisConclusionRepositorDeleteParams,
    IDiagnosisConclusionRepositorEditParams,
    IDiagnosisConclusionRepositorListData,

    IDiagnosisModelAddParams,
    IDiagnosisModelDeleteDiagnosisModelHistoryParams,
    IDiagnosisModelDeleteParams,
    IDiagnosisModelDetailHistoryData,
    IDiagnosisModelDetailHistoryParams,
    IDiagnosisModelEditHistoryParams,
    IDiagnosisModelEditParams,
    IDiagnosisModelFindPageData,
    IDiagnosisModelFindPageParams,
    IDiagnosisModelUpdateModelParams,
    IDiagnosisModelUploadParams,
    IDiagnosisNewDetailData,
    IDiagnosisNewDetailParams,
    IDiagnosisNewFindPageData,
    IDiagnosisNewFindPageParams
} from './diagnosis.types'


/**
 *  删除
 */
export function diagnosisModelDelete(params: IDiagnosisModelDeleteParams) {
    return axios({
        method: 'delete',
        url: '/diagnosis/model',
        params
    })
}

/**
 *  添加
 */
export function diagnosisModelAdd(params: IDiagnosisModelAddParams) {
    return axios({
        method: 'post',
        url: '/diagnosis/model/add',
        data: params
    })
}

/**
 *  删除历史模型
 */
export function diagnosisModelDeleteDiagnosisModelHistory(params: IDiagnosisModelDeleteDiagnosisModelHistoryParams) {
    return axios({
        method: 'delete',
        url: '/diagnosis/model/deleteDiagnosisModelHistory',
        params
    })
}
/**
 *  模型历史
 */
export function diagnosisModelDetailHistory(params: IDiagnosisModelDetailHistoryParams) {
    return axios<IDiagnosisModelDetailHistoryData>({
        method: 'get',
        url: '/diagnosis/model/detailHistory',
        params
    })
}


/**
 *  修改
 */
export function diagnosisModelEdit(params: IDiagnosisModelEditParams) {
    return axios({
        method: 'post',
        url: '/diagnosis/model/edit',
        data: params
    })
}

/**
 *  列表
 */
export function diagnosisModelFindPage(params: IDiagnosisModelFindPageParams) {
    return axios<IDiagnosisModelFindPageData>({
        method: 'post',
        url: '/diagnosis/model/findPage',
        params
    })
}

/**
 *  启用历史模型
 */
export function diagnosisModelUpdateModel(params: IDiagnosisModelUpdateModelParams) {
    return axios({
        method: 'post',
        url: '/diagnosis/model/updateModel',
        data: params
    })
}
/**
 *  模型上传
 */
export function diagnosisModelUpload(params: IDiagnosisModelUploadParams) {
    return axios({
        method: 'post',
        url: '/diagnosis/model/upload',
        data: params
    })
}

/**
 *  模型历史编辑
 */
export function diagnosisModelEditHistory(params: IDiagnosisModelEditHistoryParams) {
    return axios({
        method: 'post',
        url: '/diagnosis/model/editHistory',
        data: params
    })
}


/**
 * 删除
 */
export function diagnosisConclusionRepositorDelete(params: IDiagnosisConclusionRepositorDeleteParams) {
    return axios({
        method: 'delete',
        url: '/diagnosis/conclusionRepositor',
        params
    })
}

/**
 * 添加
 */
export function diagnosisConclusionRepositorAdd(params: IDiagnosisConclusionRepositorAddParams) {
    return axios({
        method: 'post',
        url: '/diagnosis/conclusionRepositor/add',
        data: params
    })
}

/**
 * 修改
 */
export function diagnosisConclusionRepositorEdit(params: IDiagnosisConclusionRepositorEditParams) {
    return axios({
        method: 'post',
        url: '/diagnosis/conclusionRepositor/edit',
        data: params
    })
}

/**
 * 列表
 */
export function diagnosisConclusionRepositorList() {
    return axios<IDiagnosisConclusionRepositorListData>({
        method: 'post',
        url: '/diagnosis/conclusionRepositor/findList',
    })
}


/**
 * 模型自诊断记录 列表
 */
export function diagnosisNewFindPage(params: IDiagnosisNewFindPageParams) {
    return axios<IDiagnosisNewFindPageData>({
        method: 'post',
        url: '/diagnosis/new/findPage',
        params,
    })
}


/**
 * 模型自诊断记录 详情
 */
export function diagnosisNewDetail(params: IDiagnosisNewDetailParams) {
    return axios<IDiagnosisNewDetailData>({
        method: 'get',
        url: '/diagnosis/new/getDetail',
        params,
    })
}
